import random from 'lodash/random'
import { NODES } from './constants'

const getNodeUrl = () => {
  const randomIndex = random(0, NODES.length - 1)
  return NODES[randomIndex]
}

export default getNodeUrl
